import { useMemo } from 'react'

import { useSearchContext } from '@/components/lemmala-design-system/table'

export interface HighlightRange {
  start: number
  end: number
}

/**
 * Find all occurrences of search term in text and return highlight ranges
 */
const findHighlights = (text: string, searchTerm: string): HighlightRange[] => {
  const highlights: HighlightRange[] = []
  const lowerText = text.toLowerCase()
  const lowerSearchTerm = searchTerm.toLowerCase()

  let startIndex = 0
  let index = lowerText.indexOf(lowerSearchTerm, startIndex)
  while (index !== -1) {
    highlights.push({
      start: index,
      end: index + searchTerm.length,
    })

    startIndex = index + 1
    index = lowerText.indexOf(lowerSearchTerm, startIndex)
  }

  return highlights
}

/**
 * Hook that provides highlighting functionality for AG Grid quick filter
 * Returns the current search query and a function to get highlights for any text
 */
export function useQuickFilterHighlights() {
  const search = useSearchContext()
  const searchQuery = search?.query?.trim() || ''

  const getHighlights = useMemo(
    () =>
      (text: string): HighlightRange[] => {
        if (!searchQuery || searchQuery.length < 2 || !text) {
          return []
        }
        return findHighlights(text, searchQuery)
      },
    [searchQuery],
  )

  return {
    searchQuery,
    getHighlights,
    isActive: searchQuery.length >= 2,
  }
}
